import { useState } from "react";
import { toast } from "sonner";
import { FileUp, Download } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

const HEADER = "tipo;denominazione;nome;cognome;piva;codice_fiscale;indirizzo;cap;comune;provincia;nazione;codice_destinatario;pec;email;telefono";
const SAMPLE = "cliente;Esempio Srl;;;07680350720;07680350720;Via Roma 1;70010;Adelfia;BA;IT;0000000;esempio@pec.it;info@esempio.it;080000000";

const template = () => {
  const blob = new Blob([`\ufeff${HEADER}\n${SAMPLE}\n`], { type: "text/csv;charset=utf-8" });
  const a = Object.assign(document.createElement("a"), { href: URL.createObjectURL(blob), download: "modello_clienti.csv" });
  a.click();
  URL.revokeObjectURL(a.href);
};

export const CustomerImport = ({ onDone }) => {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/customers/import", fd);
      setRes(data);
      toast.success(`${data.importati} anagrafiche importate`);
      onDone();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <>
      <Button variant="outline" className="bg-white" data-testid="import-customers-button" onClick={() => { setOpen(true); setRes(null); setFile(null); }}><FileUp className="mr-2 h-4 w-4" />Importa CSV</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg">
          <DialogHeader><DialogTitle>Importa clienti da file CSV</DialogTitle></DialogHeader>
          <p className="text-sm text-slate-600">Separatore punto e virgola o virgola, prima riga con le intestazioni. Partita IVA e codice fiscale italiani vengono controllati; le anagrafiche già presenti vengono saltate.</p>
          <Button variant="link" className="h-auto justify-start p-0 text-blue-700" data-testid="download-csv-template" onClick={template}><Download className="mr-1 h-4 w-4" />Scarica il modello CSV</Button>
          <input type="file" accept=".csv,text/csv" data-testid="import-csv-input" onChange={(e) => setFile(e.target.files[0] || null)} className="text-sm" />
          {res && (
            <div data-testid="import-result" className="max-h-48 overflow-y-auto rounded-md border border-slate-200 bg-slate-50 p-3 text-sm">
              <div className="font-semibold text-emerald-700">{res.importati} importate</div>
              {res.totale_errori > 0 && <div className="mt-1 font-semibold text-rose-700">{res.totale_errori} righe scartate</div>}
              {res.errori.map((e) => <div key={e.riga} className="text-xs text-slate-700">Riga {e.riga}: {e.errore}</div>)}
            </div>
          )}
          <DialogFooter><Button data-testid="import-csv-submit" disabled={!file || busy} onClick={send}>{busy ? "Importazione…" : "Importa"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
